var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.play
    ? _c(
        "div",
        { staticClass: "video-player-wrap" },
        [
          _c("videoPlayer", {
            ref: "videoPlayer",
            staticClass: "video-player-box",
            attrs: {
              options: _vm.playerOptions,
              playsinline: true,
              customEventName: "customstatechangedeventname",
            },
            on: {
              ended: function ($event) {
                return _vm.onPlayerEnded($event)
              },
              ready: _vm.playerReadied,
            },
          }),
          Number(_vm.options.closeEnable) === 1
            ? _c("a", {
                staticClass: "btn-close",
                attrs: { href: "javascript:;" },
                on: { click: _vm.onPlayerEnded },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }